<p-toast position="bottom-right"></p-toast>
<p-toast key="log" position="center"></p-toast>
<p-confirmDialog appendTo="body"></p-confirmDialog>
<app-support-sidebar>
  <span body>
    <span class="cc-header">
      <span class="cc-title">
        {{ 'page.' + this.transPartKey + '.title' | translate }}
      </span>
    </span>
    <app-cc-form #ccForm [transPartKey]="transPartKey"
                 [loading]="loading" [loadingProgressValue]="loadingProgressValue"
                 [submitted]="false"
                 [formConfig]="formConfig"
                 [(formRecord)]="formRecord"
    ></app-cc-form>

    <!--    <p-toolbar>-->
    <!--&lt;!&ndash;      <div class="p-toolbar-group-left">&ndash;&gt;-->
    <!--&lt;!&ndash;        <p-button [label]="'page.' + this.transPartKey + '.buttons.force_sync' | translate" icon="pi pi-sync" class="mr-2"&ndash;&gt;-->
    <!--&lt;!&ndash;                  (onClick)="doSync()"></p-button>&ndash;&gt;-->
    <!--&lt;!&ndash;        <p-button [label]="'page.' + this.transPartKey + '.buttons.force_sync_statics' | translate" icon="pi pi-sync"&ndash;&gt;-->
    <!--&lt;!&ndash;                  class="mr-2" (onClick)="doSyncStatics()"></p-button>&ndash;&gt;-->
    <!--&lt;!&ndash;        <p-button [label]="'page.' + this.transPartKey + '.buttons.force_sync_publisher' | translate" icon="pi pi-sync"&ndash;&gt;-->
    <!--&lt;!&ndash;                  class="mr-2" (onClick)="doSyncPublisher()"></p-button>&ndash;&gt;-->


    <!--&lt;!&ndash;      </div>&ndash;&gt;-->

    <!--&lt;!&ndash;      <div class="p-toolbar-group-right">&ndash;&gt;-->
    <!--&lt;!&ndash;      </div>&ndash;&gt;-->
    <!--    </p-toolbar>-->
    </span>
</app-support-sidebar>
